import { Link } from "@tanstack/react-router";

import type { InboxCardEnriched } from "@/api/db/messaging-read";
import { format } from "@/lib/format";
import { AoVivoLabels, CockpitLabels } from "@/lib/labels";

function LiveState({ card }: { card: InboxCardEnriched }) {
	if (!card.waiting || card.wait_min === null) {
		return null;
	}

	return (
		<div className="mt-1.5 text-xs text-muted-foreground">
			{AoVivoLabels.waitChip(card.wait_min)}
		</div>
	);
}

export function InboxCard({ card }: { card: InboxCardEnriched }) {
	const className = "block cursor-pointer border-t border-border py-3 first:border-t-0";

	const body = (
		<>
			<div className="flex items-baseline justify-between gap-2.5">
				<span className="min-w-0 truncate text-sm font-semibold text-foreground">
					{format.readableName(card.name) ?? CockpitLabels.unnamed}
				</span>

				<span className="shrink-0 font-mono text-xs text-muted-foreground">
					{format.time(card.last_message.sent_at)}
				</span>
			</div>

			<p className="mt-1 line-clamp-2 text-xs leading-normal text-muted-foreground">
				<span className="text-muted-foreground">
					{AoVivoLabels.speaker[card.last_message.direction]}
				</span>{" "}
				{AoVivoLabels.summary(card.last_message.text)}
			</p>

			<LiveState card={card} />
		</>
	);

	return (
		<Link
			to="/conversas"
			search={{ person: card.person_id }}
			data-component="inbox-card"
			className={className}
		>
			{body}
		</Link>
	);
}
